<template>
  <div>
    <header-applis titre="Personnaliser l’offre à votre profil" sous-titre="Dans mes activités quotidiennes, j’ai l’habitude de" index-progression-courante="3"/>
    <div class="wrapper__content">
      <div v-for="(valeur, index) in valeursPossibles" :key="index" class="checkbox-wrapper">
        <input type="checkbox" :id="'choix_' + index" :value="valeur" v-model="activitesQuotidiennes" name="statut">
        <label :for="'choix_' + index">{{ valeur }}</label>
      </div>
    </div>
    <footer-applis ecran-precedent="adapteraction" :ecran-suivant="ecranSuivant()" label-suivant="Je confirme et je passe à la suite"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';

export default {
  name: 'activitesquotidiennes',
  components: {
    FooterApplis,
    HeaderApplis
  },
  data() {
    return {
      activitesQuotidiennes: [],
      valeursPossibles: [
        'Rédiger des documents de différentes natures',
        'Travailler en équipe et partager entre collègues',
        'Réfléchir sur mes pratiques avec des experts',
        'Prendre la parole et/ou réaliser des présentations orales'
      ]
    }
  },
  computed: {
    /**
     * Récupération des informations de parcours.
     * @returns {Object} Les informations de parcours.
     */
    informationsParcours() {
      return this.$store.getters.getInformationsParcours;
    }
  },
  methods: {
    /**
     * Méthode de passage à l'écran suivant. Permet de faire les vérifications de saisie.
     */
    ecranSuivant() {
      if (!this.activitesQuotidiennes || this.activitesQuotidiennes.length === 0) {
        return '';
      }
      this.$store.commit('setActivitesQuotidiennes', this.activitesQuotidiennes);
      return 'maniereapprendre';
    }
  },
  created() {
    this.activitesQuotidiennes = this.informationsParcours.activitesQuotidiennes;
  }
}
</script>
